export function registerApplicationModules() {}
